export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-11.71dd7b7d.jpg";